/* JMT unified variant selection helpers.
 * Options are keyed by their Shopify names; prices always come from variants.
 */
(function () {
  'use strict';

  function text(value) {
    return String(value == null ? '' : value).trim();
  }

  function norm(value) {
    return text(value).toLowerCase().replace(/\s+/g, ' ');
  }

  function key(name) {
    return norm(name).replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  }

  function role(name) {
    var value = norm(name);
    if (value === 'pouch style' || value.indexOf('pouch') !== -1 || value.indexOf('cut') !== -1) return 'pouchStyle';
    if (value === 'waist size' || value.indexOf('size') !== -1) return 'waistSize';
    if (value === 'thong strap style' || (value.indexOf('strap') !== -1 && value.indexOf('style') !== -1)) return 'thongStrapStyle';
    return key(name);
  }

  function normalizeValue(optionName, value) {
    var optionRole = role(optionName);
    var result = norm(value);
    if (optionRole === 'pouchStyle') result = result.replace(/\s+cut$/, '');
    if (optionRole === 'waistSize') result = result.split(/\s+/)[0];
    return result;
  }

  function optionNames(product) {
    return (product && product.options || []).map(function (option) {
      return typeof option === 'string' ? option : option && option.name;
    }).filter(Boolean);
  }

  function selectionsFromVariant(product, variant) {
    var result = {};
    optionNames(product).forEach(function (name, index) {
      result[name] = variant && (variant.options ? variant.options[index] : variant['option' + (index + 1)]) || '';
    });
    return result;
  }

  function wantedValue(selections, optionName) {
    if (!selections) return '';
    if (selections[optionName] != null) return selections[optionName];
    var optionRole = role(optionName);
    if (selections[optionRole] != null) return selections[optionRole];
    var optionKey = key(optionName);
    if (selections[optionKey] != null) return selections[optionKey];
    return '';
  }

  function matches(product, variant, selections, requireAll) {
    var names = optionNames(product);
    for (var index = 0; index < names.length; index += 1) {
      var wanted = wantedValue(selections, names[index]);
      if (!wanted) {
        if (requireAll) return false;
        continue;
      }
      var actual = variant.options ? variant.options[index] : variant['option' + (index + 1)];
      if (normalizeValue(names[index], actual) !== normalizeValue(names[index], wanted)) return false;
    }
    return true;
  }

  function findVariant(product, selections, settings) {
    settings = settings || {};
    var variants = product && product.variants || [];
    for (var index = 0; index < variants.length; index += 1) {
      var variant = variants[index];
      if (settings.availableOnly && variant.available === false) continue;
      if (matches(product, variant, selections, settings.requireAll !== false)) return variant;
    }
    return null;
  }

  function availableValues(product, optionName, selections) {
    var names = optionNames(product);
    var target = names.indexOf(optionName);
    var values = {};
    (product && product.variants || []).forEach(function (variant) {
      if (variant.available === false) return;
      var partial = {};
      names.forEach(function (name, index) {
        if (index !== target && wantedValue(selections, name)) partial[name] = wantedValue(selections, name);
      });
      if (!matches(product, variant, partial, false)) return;
      var value = variant.options ? variant.options[target] : variant['option' + (target + 1)];
      values[norm(value)] = true;
    });
    return values;
  }

  window.JMT_VARIANTS = {
    norm: norm,
    key: key,
    role: role,
    normalizeValue: normalizeValue,
    optionNames: optionNames,
    selectionsFromVariant: selectionsFromVariant,
    wantedValue: wantedValue,
    matches: matches,
    findVariant: findVariant,
    availableValues: availableValues
  };
})();
